import cx from "classnames";
import React from "react";
import * as Scrivito from "scrivito";
import { useAccessoriesImages } from "hooks/useAccessoriesImages";
import { IconSet } from "../IconSet";
import { Icon } from "../Icon/Icon";
import { NumberInput } from "../Inputs/NumberInput";

import s from "./Product.module.scss";

export const ProductItem = ({
  isWizardProduct = false,
  preview = null,
  drag = null,
  title,
  presentationTitle,
  presentation,
  quantityTitle,
  isEditMode,
  quantity,
  handleQuantityUpdate,
  handleCopyStart,
  handleDelete,
  handleToggleEditMode,
  withIcons = true,
  productImage,
  allowProductInputOutsidePropagation = true,
  accessoriesData,
}) => {
  const hasAccessories = accessoriesData && accessoriesData.length > 0;
  const { imagesMap } = useAccessoriesImages(accessoriesData);

  return (
    <div>
      <div
        className={cx(
          "border d-flex border-box align-items-center justify-content-between text-gray-700",
          { [s.wizardProduct]: isWizardProduct },
        )}
        ref={preview}
      >
        <div className="d-flex align-items-center">
          {!isWizardProduct && drag && (
            <div ref={drag}>
              <Icon
                iconName="grip-dots-vertical"
                className="icon-12 ms-1 text-gray-400 cursor-pointer"
              />
            </div>
          )}
          {productImage ? (
            <div className="icon-64 m-2 d-flex align-items-center justify-content-center">
              <Scrivito.ImageTag
                width={64}
                content={productImage}
                className="w-100 h-100 object-fit-contain m-0"
              />
            </div>
          ) : (
            <Icon
              className="icon-64 m-2"
              prefix="trox"
              iconName="squares-light"
            />
          )}
          <div className="d-flex flex-column">
            <div className="d-flex">
              <span className="fw-bolder fs-md text-break">{title}</span>
            </div>
            <span className="text-gray-400 text-break">
              {presentationTitle}: {presentation}
            </span>
          </div>
        </div>
        <div className="me-4 pe-2 d-flex flex-nowrap">
          <div className="d-flex align-items-center pe-5">
            <span className="me-2">{quantityTitle}:</span>
            <div style={{ width: "82px" }}>
              {isEditMode ? (
                <NumberInput
                  initialValue={quantity}
                  onSave={handleQuantityUpdate}
                  updateOnChange={true}
                  allowOutsidePropagation={allowProductInputOutsidePropagation}
                  min={1}
                  max={9999}
                />
              ) : (
                quantity
              )}
            </div>
          </div>
          {withIcons && (
            <IconSet
              isEditMode={isEditMode}
              isEditable={true}
              isDuplicatable={false}
              handleToggleEditMode={handleToggleEditMode}
              onStartCopying={handleCopyStart}
              onDelete={handleDelete}
              isWizard={isWizardProduct}
            />
          )}
        </div>
      </div>

      {hasAccessories && (
        <div
          className="border-start border-gray-400"
          style={{
            height: "16px",
            width: "1px",
            marginLeft: "16px",
          }}
        />
      )}

      {hasAccessories && (
        <div className="position-relative">
          {accessoriesData.map((accessory, index) => {
            const isLastAccessory = index === accessoriesData.length - 1;
            const accessoryImage = imagesMap[accessory.pimId] || null;

            return (
              <div
                key={`accessory-${index}`}
                className="position-relative pb-2"
                style={{ paddingLeft: "32px" }}
              >
                <div
                  className="position-absolute h-100"
                  style={{ left: 0, top: 0 }}
                >
                  <div
                    className="border-start border-gray-400"
                    style={{
                      position: "absolute",
                      left: "16px",
                      top: 0,
                      height: isLastAccessory ? "50%" : "100%",
                      width: "1px",
                    }}
                  />
                  <div
                    className="border-bottom border-gray-400"
                    style={{
                      position: "absolute",
                      left: "16px",
                      top: "50%",
                      width: "16px",
                      height: "1px",
                    }}
                  />
                </div>

                <ProductItem
                  title={accessory.title}
                  quantity={quantity}
                  withIcons={false}
                  quantityTitle={quantityTitle}
                  presentationTitle={presentationTitle}
                  isEditMode={false}
                  presentation={accessory.currentPresentation}
                  productImage={accessoryImage}
                  allowProductInputOutsidePropagation={false}
                  isWizardProduct={false}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
